import icons from "../lib/icons";

function MobileSidebar() {
  return (
    <div className=" px-4 py-1  flex text-center items-center bg-primary-30 p-1 md:p-2 rounded-[18px]   justify-between w-full    ">
      <div className="flex justify-center items-center gap-1 md:gap-4">
        <div className=" flex flex-col gap-[1px] ">
          <img
            src="/images/vandabrand.png"
            className="w-8 h-8 md:w-12 md:h-12"
            alt=""
          />
          <p className="text-[8px] tracking-widest">
            {process.env.REACT_APP_VERSION}
          </p>
        </div>
        <img
          src="/images/vanda-text.svg"
          alt=""
          className="  h-6 w-12 md:h-8 md:w-20 invert "
        />
      </div>
     <div className="flex gap-2 items-center">
       <p className="text-[10px] md:text-[12px] text-[#808080] ">آموزش سایت</p>
       <img src={icons.video} className="w-4 h-4" alt="" />
     </div>
    </div>
  );
}

export default MobileSidebar;
